import {INormalizedProduct} from '../models/NormalizedProduct';

/** MIME type of a product drag out of the search results (a JSON array of IDraggedProduct). */
export const PRODUCT_DRAG_TYPE = 'application/x-ac-products';

export interface IDraggedProduct {
    id: string;
    catalog?: string;
    name?: string;
}

/** Puts the products on a native drag so any drop zone (the docked bundle editor) can add them. */
export const writeDraggedProducts = (dataTransfer: DataTransfer, products: INormalizedProduct[]): void => {
    const refs: IDraggedProduct[] = products.filter((p) => !!p?.id).map((p) => ({id: p.id, catalog: p.catalog, name: p.name}));
    dataTransfer.effectAllowed = 'copy';
    dataTransfer.setData(PRODUCT_DRAG_TYPE, JSON.stringify(refs));
    dataTransfer.setData('text/plain', refs.map((r) => r.name ?? r.id).join(', '));
};

export const hasDraggedProducts = (dataTransfer: DataTransfer | null): boolean =>
    !!dataTransfer && Array.from(dataTransfer.types ?? []).includes(PRODUCT_DRAG_TYPE);

export const readDraggedProducts = (dataTransfer: DataTransfer | null): IDraggedProduct[] => {
    if (!dataTransfer) return [];
    try {
        const parsed = JSON.parse(dataTransfer.getData(PRODUCT_DRAG_TYPE) || '[]');
        return Array.isArray(parsed) ? parsed.filter((r) => r && typeof r.id === 'string') : [];
    } catch {
        return [];
    }
};
